import React, { useState, useEffect, useContext } from "react";

import { AvForm, AvField } from "availity-reactstrap-validation";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { Picky } from "react-picky";
import { translations } from "../../../translate.js";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { CircularProgress } from "@material-ui/core";
import { MyContext } from "../../Context/MyContext";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
const Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
let today = new Date();
let currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);




export default function TransferProfitsToPointBalance({
    distId,
    permType,
    handleCloseSideBar,
    pageView,
    isAdmin
}) {
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState({});
    const [debit, setDebit] = useState(0);
    const [startSave, setStartSave] = useState(false);

    const [submitError, setSubmitError] = useState("");
    const [error, setError] = useState("");
    const [convertToBalance, setConvertToBalance] = useState(false);
    const [distBalanceAmount, setDistBalanceAmount] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [profitWithdraw, setProfitWithdraw] = useState(0);
    const { posData, setPosData } = useContext(MyContext);

    const getData = async () => {
        try {
            setStartSave(true);
            const body = JSON.stringify({
                type: "getProfitPos",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                posId: posData.userId
            });

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body,
                headers: {
                    Accept: "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data["logout"] === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else if (data["error"] === 1) {
                    setSubmitError(data["errorMsg"]);
                } else {
                    setConvertToBalance(data["convertToBalance"])
                    setDistBalanceAmount(data["distBalanceAmount"])
                    setTotalProfit(data["totalProfit"])
                    setProfitWithdraw(data["profitWithdraw"])
                    setLoading(false);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setStartSave(false);
        }
    }

    const handleTransfer = async () => {
        try {
            setStartSave(true);
            const body = JSON.stringify({
                type: "convertProfitToBalancePos",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                posId: posData.userId
            });

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body,
                headers: {
                    Accept: "application/json",
                }
            });

            const data = await response.json();

            if (data["logout"] === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else if (data["error"] === 1) {
                setLoading(false);
                alertErrorSubmite(data);
            } else {
                setLoading(false);
                alertSuccessSubmite(data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setStartSave(false);
        }
    }
    const alertErrorSubmite = (data) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                const errorMsg = data["errorMsg"]?.replace(/\\n/g, '\n');
                return (
                    <div className="custom-ui alert-box-view ">
                        <div className="mb-4">
                            <HighlightOffIcon className="error-alert-icon" size={70} />
                        </div>
                        <p className="mb-3 ">{errorMsg}</p>
                        <button
                            type="button"
                            className="btn  alert-btn-margin ml-2 mr-2 filter-empty-email label-error"
                            onClick={() => {
                                onClose();
                                getData();
                            }}
                        >
                            {Strings.Close}
                        </button>
                    </div>
                );
            },
        });
    };
    const alertSuccessSubmite = (data) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                const successMsg = data["errorMsg"]?.replace(/\\n/g, '\n');
                return (
                    <div className="custom-ui alert-box-view ">
                        <div className="mb-4">
                            <CheckCircleOutlineIcon className="success-alert-icon" />
                        </div>
                        <p className="mb-3 ">{successMsg}</p>
                        <button
                            type="button"
                            className="btn  alert-btn-margin ml-2 mr-2 success-btn text-success"
                            onClick={() => {
                                onClose();
                                getData();
                            }}
                        >
                            {Strings.Close}
                        </button>
                    </div>
                );
            },
        });
    };
    const getUserInfoPOS = async () => {
        try {
            setStartSave(true);
            const body = JSON.stringify({
                type: "getUserInfoPOS",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN")
            });

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body,
                headers: {
                    Accept: "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data["logout"] === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    setState(prevState => ({
                        ...prevState,
                        posId: data["userId"]
                    }));
                }
            }
        } catch (error) {
            console.error(error);
            setError("An error occurred while fetching user info");
        } finally {
            setStartSave(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="view-modal-style">
            <div className="sidebar-header-view">
                <Row>
                    <Col md={10} xs={10} lg={10} sm={10}>
                        <div className="p-0 main-color-1  sidebar-header-title">
                            {`${Strings["Transfer profits to point balance"]} : (${posData["fname"]} ${posData["lname"]})`}
                        </div>
                    </Col>
                    {/* <Col md={2} xs={2} lg={2} sm={2} className="text-right">
                        <HighlightOffIcon
                            onClick={handleCloseSideBar}
                            className="modal-close-icon"
                        />
                    </Col> */}
                </Row>
            </div>
            <div className="">

                {loading && (
                    <Row>
                        <Col md={12} style={{ marginTop: "15%" }} className="text-center">
                            <div className="card-body">
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                            </div>
                        </Col>

                    </Row>
                )}
                {!loading && (<div className="text-right mt-4">

                    <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 1, 900: 1 }}>
                        <Masonry>

                            {submitError && (
                                <div className="alert alert-danger" role="alert" style={{ backgroundColor: "rgb(246, 33, 0,0.8)", color: "white", fontWeight: "bold" }}>
                                    {submitError}
                                </div>
                            )}
                            <div className='supplier-api-section-box  mb-4 '>
                                <Row>
                                    <Col className='mb-3 bold-font text-start' lg={12} md={12} sm={12} xs={12}>{Strings["profits"]} </Col>
                                    <hr />
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5 className='text-start mt-2 mb-2'>{Strings["Balance"]} :  {distBalanceAmount}</h5>
                                        <h5 className='text-start mt-2 mb-2'>{Strings["The Profit you can withdraw from last months"]} :  {profitWithdraw}</h5>
                                        <h5 className='text-start mt-2 mb-2'>{Strings["Profit For this month"]} :  {totalProfit}</h5>
                                    </Col>
                                </Row>
                            </div>

                        </Masonry>
                    </ResponsiveMasonry>

                    <button type="button" className="btn form-save-btn mr-1 ml-1" onClick={handleTransfer}  >
                        {Strings["Transfer Profit to wallet"]}
                    </button>

                </div>)}
            </div>
        </div>
    );
}
